/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px #3031331A;
  left: ${(props) => props.left || 0}px;
  top: ${(props) => props.top || 0}px;
  gap: 4px;
  overflow-y: auto;
  min-width: 160px;
  max-width: 200px;
`;

const PaceOption = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;
  background: white;
  border: 1px solid transparent;

  &:hover {
    background: #F5F5F5;
  }
`;

const PacePickerPopup = ({
  left,
  top,
  openTop = false,
  spaceAbove = null,
  assignedPace,
  setAssignedPace,
}) => {
  const containerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('none');
  const [chosenPace, setChosenPace] = useState(assignedPace || null);
  const calendarContainerScrollPosition = useSelector((state) => state.calendar.data.calendarContainerScrollPosition);

  console.log('assignedPace', assignedPace);

  // Pace options based on SwapPropDropdownSAQC.js
  const paceOptions = [
    'Speed-1',
    'Speed-2',
    'Speed-3',
    'Current PR',
    'Interval-1',
    'Interval-2',
    'Interval-3',
    'Threshold-1',
    'Threshold-2',
    'Threshold-3',
    'Easy-1',
    'Easy-2',
    'Easy-3',
    'Recovery',
    '12k Target',
    '10k Target',
    '8k Target',
    '6k Target',
    '5k Target',
    '4k Target',
    '3k Target',
    '2k Target',
    '1k Target',
  ];

  useEffect(() => {
    const updateMaxHeight = () => {
      if (containerRef?.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.top - 10; /** 10px padding from bottom */
        setMaxHeight(spaceBelow);
      }
    };

    /** Initial set */
    updateMaxHeight();

    /** Add listener */
    window.addEventListener('resize', updateMaxHeight);

    /** Cleanup */
    return () => {
      window.removeEventListener('resize', updateMaxHeight);
    };
  }, [calendarContainerScrollPosition]);

  const handleClick = (pace) => {
    setChosenPace(pace);
    setAssignedPace(pace);
  };

  return (
    <Container
      ref={containerRef}
      onClick={(e) => {
        e.stopPropagation();
      }}
      left={left}
      top={top}
      style={{ maxHeight: openTop ? spaceAbove : maxHeight }}
    >
      {/* None/Clear option */}
      <PaceOption
        onClick={() => {
          console.log('pace');
          handleClick(null);
        }}
      >
        <Text fontSize='14px' color='#9E9E9E'>
          None
        </Text>
        {(chosenPace === null || chosenPace === '') && (
          <IcomoonReact
            iconSet={iconSet}
            size={12}
            icon='checkmark'
            color='#9E9E9E'
          />
        )}
      </PaceOption>

      {/* Pace options */}
      {paceOptions.map((pace) => (
        <PaceOption
          key={pace}
          onClick={() => handleClick(pace)}
        >
          <Text fontSize='14px' color='#444444'>
            {pace}
          </Text>
          {chosenPace === pace && (
            <IcomoonReact
              iconSet={iconSet}
              size={12}
              icon='checkmark'
              color='#9E9E9E'
            />
          )}
        </PaceOption>
      ))}
    </Container>
  );
};

export default PacePickerPopup;
